var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotorhome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1282 73.1571H54.0129M78.209 73.1571H91.3347M113.633 73.1571H134.509",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5575 89.629C69.5886 89.629 72.8566 86.3611 72.8566 82.3299C72.8566 78.2987 69.5886 75.0308 65.5575 75.0308C61.5263 75.0308 58.2584 78.2987 58.2584 82.3299C58.2584 86.3611 61.5263 89.629 65.5575 89.629Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1529 82.4874C76.1529 76.5483 71.409 71.7333 65.5572 71.7333C59.7054 71.7333 54.9615 76.5483 54.9615 82.4874",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.96 82.4874C153.96 76.5483 149.217 71.7333 143.365 71.7333C137.513 71.7333 132.769 76.5483 132.769 82.4874",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.365 89.629C147.396 89.629 150.664 86.3611 150.664 82.3299C150.664 78.2987 147.396 75.0308 143.365 75.0308C139.333 75.0308 136.065 78.2987 136.065 82.3299C136.065 86.3611 139.333 89.629 143.365 89.629Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7858 84.3864H131.979",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.695 84.3846C153.697 84.3324 155.7 84.0057 155.7 83.1201C155.7 82.2345 155.7 75.2649 155.7 71.8917L150.22 58.7787M142.415 40.1043C141.466 37.8376 137.513 33.3041 129.289 33.3041C121.066 33.3041 60.4966 33.3041 31.2397 33.3041C29.0784 33.4095 24.6925 34.9171 24.4395 40.1043C24.1864 45.2914 24.334 63.4569 24.4395 71.8917C24.5449 80.3256 24.4394 84.3846 30.1326 84.3846C35.8258 84.3846 49.5844 84.3846 55.752 84.3846",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.216 49.5314L140.91 43.3658H136.313V62.7531H148.161L146.75 58.983",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.708 43.8159H122.761V62.3027H133.708V43.8159Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.075 48.3282C112.075 43.3363 108.028 39.2895 103.037 39.2895C98.0446 39.2895 93.9978 43.3363 93.9978 48.3282V72.3662C93.9978 77.3581 98.0446 81.4049 103.037 81.4049C108.028 81.4049 112.075 77.3581 112.075 72.3662V48.3282Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.195 43.7174H103.195C100.387 43.7174 98.1099 45.9941 98.1099 48.8025V56.3934C98.1099 59.2018 100.387 61.4785 103.195 61.4785H103.195C106.003 61.4785 108.28 59.2018 108.28 56.3934V48.8025C108.28 45.9941 106.003 43.7174 103.195 43.7174Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2258 84.2919V51.9808H30.7618V84.2919",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3385 39.2895H35.8009V48.8271H45.3385V39.2895Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9287 36.3082H128.499",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M155.7 71.8935H151.272L153.486 75.2145",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.251 66.831H109.205",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.134 41.5026H144.606V57.3659H148.134V41.5026Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2143 30.75H44.0252V33.0129H66.2143V30.75Z",
    stroke: "black",
    strokeOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorhome);
export default __webpack_public_path__ + "static/media/motorhome.b70b30ddc2823965e2f366ad486dc13a.svg";
export { ForwardRef as ReactComponent };